import { render } from "./company-detail.vue?vue&type=template&id=7582332a"
import script from "./company-detail.vue?vue&type=script&lang=js"
export * from "./company-detail.vue?vue&type=script&lang=js"

import "./company-detail.vue?vue&type=style&index=0&id=7582332a&lang=css"

import exportComponent from "D:\\SphinxProjects\\VUE3\\Excel_Library_Frontend_Website\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__